import React from 'react'

import './Title.css'

const Title = () => {
  return (
    <div className='cont-title'>
      <p className='p-title'>
        <span className="maj-title">J</span>
        érôme
        <span className="maj-title"> P</span>
        otié
      </p>
    </div>
  )
}

export default Title